import { useEffect, useState } from "react";
import { showToast } from "../../../../components/custom/custom-toast";
import { DetailRow } from "../../../../components/custom/detail-row";
import { ModalCustom } from "../../../../components/custom/modal-custom";
import { useFetchData } from "../../../../hooks/useFetch";
import { CompaniesResponse } from "../../../../models/response/companies";
import { API_COMPANIES_ROUTER } from "../../../../services/api-config";

interface CompaniesDetailProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  dataObject: CompaniesResponse;
}

export const CompaniesDetail = ({ dataObject, isOpen, setIsOpen }: CompaniesDetailProps) => {
  const [dataDetail, setDataDetail] = useState<CompaniesResponse>(new CompaniesResponse());
  const { request: fetchDataDetail, baseResponse: responsesDetail } = useFetchData.Get<CompaniesResponse>();

  useEffect(() => {
    if (!isOpen) return;
    if (dataObject._id != "") {
      fetchDataDetail({
        endPoint: API_COMPANIES_ROUTER.API_GET_COMPANIES_DETAIL(dataObject._id),
      });
    }
  }, [dataObject, isOpen]);

  useEffect(() => {
    if (!responsesDetail) return;
    if (responsesDetail.status === 200) {
      setDataDetail(responsesDetail.data);
    } else {
      showToast({ message: responsesDetail.message, type: "error" });
    }
  }, [responsesDetail]);

  const bodyModal = () => {
    return (
      <div className="flex flex-col">
        <div className="grid grid-cols-1  gap-2">
          <DetailRow label="Tên công ty:" value={dataDetail?.name} />
          <DetailRow label="Số điện thoại:" value={dataDetail?.phone} />
          <DetailRow label="Địa chỉ:" value={dataDetail?.address} />
          <DetailRow label="Mô tả:" value={dataDetail?.description} />
          <DetailRow label="Ngày tạo:" value={dataDetail?.created_at} />
          <DetailRow label="Ngày cập nhật:" value={dataDetail?.updated_at} />
        </div>
      </div>
    );
  };

  return (
    <ModalCustom
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      titleModal="Chi tiết công ty"
      bodyModal={bodyModal()}
      modalSize="40%"
    />
  );
};
